module.exports = __webpack_public_path__ + "../assets/styles/theme.scss.liquid";